import { VContainer } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return (!!_vm.dataset)?_c(VContainer,[_c('toolbar',{attrs:{"mode":"dataset","item":_vm.dataset}}),(_vm.dataset)?_c('dataset',{ref:"dataset",attrs:{"item":_vm.dataset},on:{"submitted":_vm.onSubmit}}):_vm._e()],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }